import { Component, Injector, OnDestroy, OnInit, Inject, HostListener } from "@angular/core";
import { MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Title } from "@angular/platform-browser";
import { TranslateService } from "@ngx-translate/core";
import { UserService } from "../../shared/services/user.service";
import { LoginDialogComponentComponent } from "../login-dialog-component/login-dialog-component.component";
import { NotificationService } from "../services/notification.service";
import { RestApiService } from "../services/restapi.service";

@Component({
  selector: 'app-forgot-dialog',
  templateUrl: './forgot-dialog.component.html',
  styleUrls: ['./forgot-dialog.component.scss']
})
export class ForgotDialogComponent implements OnInit, OnDestroy {
  public forgotPasswordData: any = {
    userName: ''
  };
  public loadingDetails: boolean = true;
  public forgotpasswordtype: string = '';
  public sentEmail: boolean = false;
  public ConfirmPass: boolean = false;
  _forMobileScreen:any=false
  constructor(
    @Inject(MAT_DIALOG_DATA) public LoginDialogData: any,
    private inject: Injector,
    private titleService: Title,
    public translate: TranslateService,
    public notificationService: NotificationService,
    public apiServie: RestApiService,
    public userService: UserService) {
    document.body.classList.add("formodal")
  }

  ngOnInit(): void {
    this._forMobileScreen = window.innerWidth <= 700;
    this.translate.get('global_Company_Title').subscribe((text: string) => {
      this.titleService.setTitle(this.translate.instant('pagetitle_forgotpassword') + ' | ' + text);
    });

    if (this.LoginDialogData.forNewPass) {
      this.ConfirmPass = true;
    }
  }

  emailSentForgotPassword() {
    this.loadingDetails = true;
    // let link = window.location.origin + '/' + window.location.pathname.split('/')[1] + '/' + 'resetPassword'
    const forgotPasswordRequest = {
      value: this.forgotPasswordData.userName,
      valType: 'email'
    };
    this.apiServie.triggerForgotPasswordProcess(forgotPasswordRequest).subscribe((result) => {
      if (result?.Message == 'Success' && result?.Data?.Data?.Result == true) {
        this.loadingDetails = false;
        this.forgotPasswordData.userName = '';
        this.sentEmail = true;
        this.notificationService.success(
          'Success',
          `A password reset email has been sent to ${forgotPasswordRequest.value}. Please check your inbox.`
        );
      } else {
        this.notificationService.error('Error', 'Password reset request failed. Please try again.');
      }
    }, (error) => {
      this.loadingDetails = false;
      this.notificationService.error('Error', 'Something went wrong. Please try again later.');
    });
  }
  backtologin() {
    const Dialog = this.inject.get(MatDialog);
    Dialog.open(this.LoginDialogData, {
      width: "600px",
      autoFocus: false
    });
  }

  ForgotPassword() {
    let customerid = this.LoginDialogData.id
    let req = {
      newPassword: this.forgotPasswordData.userName
    }
    this.apiServie.thirdForgotPasswordProcess(customerid, req).subscribe((data) => {
      if (data.Message == 'Success') {
        this.loadingDetails = false;
        this.forgotPasswordData.userName = '';
        this.sentEmail = true;
      } else {
        this.notificationService.error('error', 'Please Try Again!')
      }
    })
  }

  ngOnDestroy(): void {

    document.body.classList.remove("formodal")
  }
  @HostListener('window:resize', ['$event'])
  onWindowResize(event: Event) {
    this.windowResize(event);
  }
  windowResize(event: Event): void {
    this._forMobileScreen = window.innerWidth <= 700;
  }
}
